import isBlank from 'is-blank'

export default person => {
  if (person.constructor !== Object) {
    throw new TypeError('person has to be an object.')
  }
  const { firstName, lastName, email } = person
  const fullName = [firstName, lastName]
  .filter(p => !isBlank(p))
  .join(' ')
  return isBlank(fullName) ? email : fullName
}



// WEBPACK FOOTER //
// ./src/filters/fullName.js